import {
  ILoginFormData,
  IResetPasswordFormData,
  ISignupFormData,
  IChangePasswordFormData,
  IEditProfileFormData,
} from "@model/Authentication.model";
import {
  IValidationRule,
  ValidationRuleType,
} from "../../Model/UIComponents.model";
import { IContactFormData, ICreateCategoryProps } from "@model/MainPages.model";
import { DeliveryLocationFormValues } from "@model/Cart.model";
import { ICreateProductProps } from "@model/Category.model";
import { ICreateDepartmentFormData } from "@model/Department.model";
import { IReplyInquiryFormData } from "@model/contactus.model";
import { ICreateDeliveryAddressFormData } from "@model/DeliveryAddress.model";

export const passwordRules: IValidationRule[] = [
  { type: ValidationRuleType.LENGTH, requiredOccurrences: 8 },
  { type: ValidationRuleType.SPECIAL_CHARS, requiredOccurrences: 1 },
  { type: ValidationRuleType.DIGITS, requiredOccurrences: 1 },
  { type: ValidationRuleType.UPPERCASE, requiredOccurrences: 1 },
  { type: ValidationRuleType.LOWERCASE, requiredOccurrences: 1 },
];

export const defaultSignUpValues: ISignupFormData = {
  firstName: "",
  lastName: "",
  email: "",
  phoneNumber: "",
  password: "",
  confirmPassword: "",
  agreeToPolicy: false,
  accountType: "client",
};

export const defaultEditProfileValues: IEditProfileFormData = {
  firstName: "",
  lastName: "",
  email: "",
  phoneNumber: "",
  accountType: "client",
};

export const defaultLoginValues: ILoginFormData = {
  email: "",
  password: "",
};
export const defaultInquirieValues: IReplyInquiryFormData = {
  title: "",
  message: "",
};

export const defaultDeliveryAddressValues: ICreateDeliveryAddressFormData = {
  addressLabel: "",
  street: "",
  houseNumber: "",
  city: "",
  region: "",
  country: "",
  postalCode: "",
  additionalInformation: "",
  isDefaultAddress: false,
};

export const defaultResetPasswordFormValues: IResetPasswordFormData = {
  newPassword: "",
  confirmPassword: "",
};
export const defaultChangePasswordFormValues: IChangePasswordFormData = {
  oldPassword: "",
  newPassword: "",
  confirmPassword: "",
};

export const defaultContactValues: IContactFormData = {
  subject: "",
  firstName: "",
  lastName: "",
  phoneNumber: "",
  email: "",
  message: "",
};

export const defaultDeliveryValues: DeliveryLocationFormValues = {
  street: "",
  city: "",
  region: "",
  postalCode: "",
  houseNumber: "",
};

export const defaultValues: ICreateCategoryProps = {
  title: "",
  description: "",
  image: {} as FileList,
};

export const defaultValuesProduct: ICreateProductProps = {
  categoryId: "",
  name: "",
  price: "",
  shortDescription: "",
  longDescription: "",
  stock: "",
  specs: [],
  images: null,
  files: null,
};

export const defaultValuesModalDepartment: ICreateDepartmentFormData = {
  name: "",
  description: "",
  headOfDepartmentUserId: "",
};


export const defaultEditValues: ICreateProductProps = {
  name: "",
  price: "",
  shortDescription: "",
  longDescription: "",
  stock: "",
  specs: [{ label: "", value: "" }],
  images: null as any,
  categoryId: "",
  files: null,
};